import { MedalIcon as PhosphorMedalIcon } from "@phosphor-icons/react/dist/ssr/Medal";

import { createAppIcon } from "@/components/createAppIcon";

export const PremiumIcon = /* @__PURE__ */ createAppIcon(PhosphorMedalIcon);
